module.exports = __webpack_public_path__ + "img/simone1.f96da47f.jpg";